/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const UserIcon = /*#__PURE__*/ createSvgIcon(
  'UserIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.02 2.5a2.479 2.479 0 100 4.957 2.479 2.479 0 000-4.957zM4.543 4.979a3.479 3.479 0 116.957 0 3.479 3.479 0 11-6.958 0zM5.402 9.016a.5.5 0 01.358.04c.672.351 1.45.541 2.247.544a4.861 4.861 0 002.232-.543.5.5 0 01.358-.04C13.135 9.677 14.5 11.841 14.5 14h-1c0-1.69-1.03-3.377-2.978-3.966a5.885 5.885 0 01-2.513.566h-.004a5.943 5.943 0 01-2.526-.566C3.542 10.623 2.5 12.31 2.5 14h-1c0-2.16 1.379-4.322 3.902-4.984z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.027 2.5a3.473 3.473 0 100 6.945 3.473 3.473 0 000-6.945zM5.554 5.973a4.473 4.473 0 118.946 0 4.473 4.473 0 01-8.946 0zM6.58 11.516a.5.5 0 01.357.04 6.73 6.73 0 003.073.744 6.649 6.649 0 003.051-.743.5.5 0 01.36-.04c3.305.861 5.079 3.675 5.079 6.483h-1c0-2.34-1.439-4.676-4.152-5.467a7.676 7.676 0 01-3.336.767h-.004a7.759 7.759 0 01-3.355-.767C3.954 13.324 2.5 15.661 2.5 18h-1c0-2.81 1.793-5.622 5.08-6.484z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.034 2.5a4.467 4.467 0 10.002 8.934 4.467 4.467 0 00-.002-8.934zM6.568 6.966a5.467 5.467 0 1110.934.002 5.467 5.467 0 01-10.934-.002zM15.868 13.348a.5.5 0 01.386-.048c4.093 1.17 6.246 4.961 6.246 8.7h-1c0-3.323-1.87-6.593-5.324-7.68a8.845 8.845 0 01-4.162 1.057h-.004a8.93 8.93 0 01-4.185-1.056C4.39 15.408 2.5 18.679 2.5 22h-1c0-3.74 2.178-7.53 6.245-8.7a.5.5 0 01.386.047 7.916 7.916 0 003.881 1.03 7.834 7.834 0 003.856-1.03z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default UserIcon;
